import { css, Theme } from '@emotion/react';

export const AmountTotalsStyles = (theme: Theme) =>
  css({
    backgroundColor: theme.colors.lightestBlue,
    margin: '10px 5px',
    borderRadius: 10,
  });
